import React, { useState, ReactNode, useEffect } from 'react';
import { useSelector } from 'react-redux';

import Axios from 'axios';
import { RootState } from 'store';

import { TravelDetails as TravelDetailsType } from 'models/travelDetails';
import { getTravelDetailById } from 'services/travelService';

type Props = {
  travelId: string;
  render(loading: boolean, travelDetails?: TravelDetailsType): ReactNode;
};

const TravelDetailsContainer = ({ travelId, render }: Props) => {
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState<TravelDetailsType>();

  const user = useSelector((state: RootState) => ({
    isLoading: state.user.isLoading,
    accountResult: state.user.accountResult,
  }));

  useEffect(() => {
    const cancelSource = Axios.CancelToken.source();

    if (!user.isLoading && user.accountResult) {
      getTravelDetailById({ TravelId: travelId, cancelToken: cancelSource.token })
        .then(({ data }) => {
          setResponse(data);
          setLoading(false);
        })
        .catch((error) => {
          if (!Axios.isCancel(error)) {
            throw error;
          }
        });
    }

    return () => {
      cancelSource.cancel();
    };
  }, [user.isLoading, user.accountResult, travelId]);

  return <>{render(loading, response)}</>;
};

export default TravelDetailsContainer;
